import api from './api';

export const sliderService = {
    getList: async (params = {}) => {
        try {
            const response = await api.get('/sliders-admin', { params });
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    getDetail: async (id) => {
        try {
            const response = await api.get(`/sliders-admin/${id}`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data' };
        }
    },

    create: async (formData) => {
        try {
            const response = await api.post('/sliders-admin', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menyimpan'
            };
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.post(`/sliders-admin/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate'
            };
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/sliders-admin/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal menghapus' };
        }
    },

    toggleActive: async (id) => {
        try {
            const response = await api.post(`/sliders-admin/${id}/toggle-active`);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, message: 'Gagal mengubah status' };
        }
    },

    reorder: async (items) => {
        try {
            const response = await api.post('/sliders-admin/reorder', { items });
            return { success: true, message: response.data.message };
        } catch (error) {
            return { success: false, message: 'Gagal mengurutkan' };
        }
    },
};

export default sliderService;